import React, { Component } from "react";
import { GenericEditPanel } from "com-gyf-webcore-userinterfacecomponents";

class FormaPagoDebitoCuenta extends Component {
    constructor(props) {
        super(props);
    }
    /**
     * 
     * @param {any} novedad
     * @param {any} estadoId
     * @param {any} entidadId
     */
    actualizarNovedadEstado(novedad, estadoId, entidadId) {
        this.props.actualizarNovedadEstado(novedad.Id, estadoId, this.props.codigoNovedad, novedad.NovedadTipoId, this.props.cuentaTarjetaId)
    }
    /**
     * 
     * @param {any} event
     */
    selectCombo(event) {
        this.props.selectCombo(1, this.props.codigoNovedad, event.target.value)
    }
    /**
     * 
     */
    render() {
        const { codigoNovedad, cuentaTarjetaId, data, esNovedadEditada,
            funcionesDelUsuario, novedades, seEstaEditando, formasPagoDebito,
            cuentaTarjetaEstadoId } = this.props;

        let formaDebitoId = (data || 0);
        let formaDebitoIdDescripcion = "Sin especificar";
        let novedad = undefined;

        if (novedades && novedades.length > 0) {
            /*Busco el max id de las novedades generadas*/
            const novedadId = Math.max(...novedades.map(n => n.Id));
            /*Obtengo esa novedad*/
            novedad = novedades.find(n => n.Id == novedadId);

            if (novedad) {
                if (esNovedadEditada == false) {
                    formaDebitoId = novedad.ValorNovedad;
                }

                novedad.ValorAnteriorFormateado = "Sin especificar";
            }
        }

        formasPagoDebito.forEach(s => {
            if (s.Id == formaDebitoId) {
                formaDebitoIdDescripcion = s.Descripcion;
            }

            if (novedad) {
                if (s.Id == novedad.ValorAnterior) {
                    novedad.ValorAnteriorFormateado = s.Descripcion;
                }
            }
        });

        const componente = (
            <select className="form-control default-select" value={formaDebitoId} onChange={this.selectCombo.bind(this)}>
                <option value="0">Seleccione...</option>
                {(formasPagoDebito || []).map((model, index) => {
                    return (
                        <option value={model.Id} key={"modelo-option-" + index}>
                            {model.Descripcion}
                        </option>
                    );
                })}
            </select>
        );

        /*si es Seleccionar no lo guardo*/
        const error = (formaDebitoId == 0);

        return (
            <GenericEditPanel
                componente={componente}
                cuenta={{ CuentaTarjetaEstadoId: cuentaTarjetaEstadoId }}
                error={error}
                novedad={novedad}
                permisoUsuario={funcionesDelUsuario}
                seEstaEditando={seEstaEditando}
                textPanel={formaDebitoIdDescripcion}
                title="Importe a debitar"
                value={formaDebitoId}

                aceptChanges={(value) => this.props.guardarNovedad(value)}
                confirmarNovedad={() => this.actualizarNovedadEstado(novedad, 2)}
                changeEditMode={(value) => this.props.estadoEdicion(value, this.props.codigoNovedad)}
                denegarNovedad={() => this.actualizarNovedadEstado(novedad, 3)}
                mostrarModificaciones={this.props.mostrarModal}
                revert={this.props.cancelar} />
        );
    }
}

export default FormaPagoDebitoCuenta;